import styled from "styled-components";
import { V3Body, V3Title } from "../../../components/Typography";
import { media } from "../../../theme/theme";

export const V3RefDashboard = styled.div`
    border-radius: 18px;
    background: ${({ theme }) => theme ? theme.v3.colors.blue : null};
    text-align: center;
    color: white;
    padding: 40px 24px 100px;

    ${V3Title}, ${V3Body} {
        color: white;
    }
`;

export const RefDashboarPanel = styled.div`
    background: white;
    width: 100%;
    max-width: calc(100% - 24px);
    margin: -116px auto 0;
    border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
    border-radius: 18px;

    ${media.custom(640)} {
        max-width: calc(100% - 96px);
    }
`;

export const RefDashTopPanel = styled.div`
    padding: 24px;
    align-items: flex-end;

    ${media.custom(640)} {
        padding: 24px 40px;
    }

    ${media.custom(640)} {
        display: flex;
    }

    > div {
        &:first-child {
            margin-bottom: 20px;
            width: 100%;

            ${media.custom(640)} {
                margin-right: 24px;
                margin-bottom: 0;
            }
        }
    }
`;

export const RefDashboardBottomPanelCard = styled.div`
    border-top: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
    padding: 31px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    ${media.custom(450)} {
        width: 50%;
    }

    ${media.custom(1180)} {
        width: 25%;
    }
`;

export const RefDashboardBottomPanel = styled.div`
    display: flex;
    flex-wrap: wrap;

    ${RefDashboardBottomPanelCard} {
        &:first-child {
            ${media.custom(450)} {
                border-right: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
            }
        }

        &:nth-child(2) {
            ${media.custom(1180)} {
                border-right: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
            }
        }

        &:nth-child(3) {
            ${media.custom(450)} {
                border-right: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
            }
        }        
    }
`;

export const RefSocialWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;

    > div {
        display: inline-flex;
        &:first-child {
            margin-right: 8px;
        }
    }
`;

export const ReferralMaxWidth = styled.div`
    max-width: 800px;
    margin: 0 auto;
`;